/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var AttachLinkOffIcon16Regular = forwardRef('AttachLinkOffIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M2.28 1.22a.75.75 0 0 0-1.06 1.06l12.5 12.5a.75.75 0 1 0 1.06-1.06l-1.533-1.534A4.75 4.75 0 0 0 11 3.25H9.75a.75.75 0 0 0 0 1.5H11a3.25 3.25 0 0 1 1.114 6.304L9.811 8.75h1.439a.75.75 0 0 0 0-1.5H8.31l-2.5-2.5h.44a.75.75 0 0 0 0-1.5H5c-.22 0-.435.015-.646.044L2.28 1.22Z" }),
        React.createElement("path", { d: "M.25 8c0-1.37.58-2.606 1.51-3.473L2.82 5.59A3.25 3.25 0 0 0 5 11.25h1.25a.75.75 0 0 1 0 1.5H5A4.75 4.75 0 0 1 .25 8Z" }),
        React.createElement("path", { d: "M3.75 8a.75.75 0 0 1 .732-.75l1.5 1.5H4.5A.75.75 0 0 1 3.75 8Z" })));
});
